import env from '@travel/env';
import { fetchDisabledComponentApi } from './api';
import { isEmptyObject } from '@travel/utils';
import generateLogger from '@travel/logger';
import { DisabledComponent } from 'Common-Types';
import { AppThunk, createAsyncAction, createStandardAction } from 'typesafe-actions';

const logger = generateLogger();

export const setIsPackagePrice = createStandardAction('SET_COMMON_IS_PACKAGE_PRICE').map(
  (payload: boolean) => ({
    payload,
  }),
);

export const setUserIdentifier = createStandardAction('SET_USER_IDENTIFIER')<string>();

export const fetchDisabledComponentAsync = createAsyncAction(
  'FETCH_COMPONENT_REQUEST',
  'FETCH_COMPONENT_SUCCESS',
  'FETCH_COMPONENT_FAILURE',
)<undefined, DisabledComponent, undefined>();
export const fetchDisabledComponent = (): AppThunk => async (dispatch, getState, { apiClient }) => {
  const { common } = getState();
  //do not fetch when data has been fetched
  if (!env('UNIVERSAL_DISABLED_COMPONENT_URL') || !isEmptyObject(common.isDisabledComponent))
    return;

  dispatch(fetchDisabledComponentAsync.request());
  try {
    const response = await fetchDisabledComponentApi(apiClient);
    dispatch(fetchDisabledComponentAsync.success(response));
  } catch (error) {
    logger.error(error);
    dispatch(fetchDisabledComponentAsync.failure());
  }
};
